<mat-form-field [appearance]="appearance()" class="w-full">
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  }
  <mat-date-range-input
    [rangePicker]="picker"
    [formGroup]="formGroup()"
    [min]="minDate()"
    [max]="maxDate()"
  >
    <input
      matStartDate
      readonly
      (click)="picker.open()"
      [formControlName]="startControlName()"
      [placeholder]="startPlaceholder() ?? ('GENERAL.data_inizio' | translate)"
    />
    <input
      matEndDate
      readonly
      (click)="picker.open()"
      [formControlName]="endControlName()"
      [placeholder]="endPlaceholder() ?? ('GENERAL.data_fine' | translate)"
    />
  </mat-date-range-input>
  <mat-datepicker-toggle matIconSuffix [for]="picker" />
  <mat-date-range-picker #picker (closed)="onClosed()">
    @if (withActions()) {
      <mat-date-range-picker-actions>
        <button matButton matDateRangePickerCancel>
          {{ 'GENERAL.cancel' | translate }}
        </button>
        <button matButton="elevated" matDateRangePickerApply>
          {{ 'GENERAL.select' | translate }}
        </button>
      </mat-date-range-picker-actions>
    }
  </mat-date-range-picker>
  @if (hint()) {
    <mat-hint>{{ hint() }}</mat-hint>
  }
  <mat-error siatErrorField [control]="startControl()" [label]="label()" />
  <mat-error siatErrorField [control]="endControl()" [label]="label()" />
</mat-form-field>
